<template>
  <div>
    <v-select
      :items="comparadores"
      label="Criação"
      item-text="text"
      item-value="value"
      v-model="comparadorSelecionado"
    />
    <div v-show="showDataPicker">
      <v-menu
        v-model="di"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dataCriacaoInicio"
            label="Data criação inicial"
            prepend-icon="event"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker no-title @input="selecionarDataCriacaoInicio" />
      </v-menu>
    </div>
    <div v-show="showDataFimPicker">
      <v-menu
        v-model="df"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dataCriacaoFim"
            label="Data criação final"
            prepend-icon="event"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker no-title @input="selecionarDataCriacaoFim" :min="dataCriacaoInicioSelecionada" />
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroDataCriacao',
  data() {
    const hoje = new Date().toLocaleDateString()
    return {
      di: false,
      df: false,
      dataCriacaoInicio: hoje,
      dataCriacaoFim: hoje,
      comparadores: [
        {
          text: 'Não comparar',
          value: null
        },
        {
          text: 'Criado antes de',
          value: '<'
        },
        {
          text: 'Criado depois de',
          value: '>'
        },
        {
          text: 'Criado no período',
          value: '<>'
        }
      ],

      dataCriacaoInicioSelecionada: this.parseData(hoje),
      dataCriacaoFimSelecionada: this.parseData(hoje),
      comparadorSelecionado: null
    }
  },
  computed: {
    tudo() {
      return `${this.dataCriacaoInicioSelecionada}|${this.dataCriacaoFimSelecionada}|${this.comparadorSelecionado}`
    },
    showDataPicker() {
      return this.comparadorSelecionado !== null
    },
    showDataFimPicker() {
      return this.comparadorSelecionado === '<>'
    }
  },
  watch: {
    tudo() {
      this.$emit('filtrar-data-criacao', {
        data_criacao_inicio: this.dataCriacaoInicioSelecionada,
        data_criacao_fim: this.dataCriacaoFimSelecionada,
        comparador_criacao: this.comparadorSelecionado
      })
    }
  },
  methods: {
    parseData(data) {
      let [dia, mes, ano] = data.split('/')
      return `${ano}-${mes}-${dia}`
    },
    selecionarDataCriacaoInicio(value) {
      this.dataCriacaoInicio = this.toDate(value).toLocaleDateString()
      this.dataCriacaoInicioSelecionada = value
      this.di = false
    },
    selecionarDataCriacaoFim(value) {
      this.dataCriacaoFim = this.toDate(value).toLocaleDateString()
      this.dataCriacaoFimSelecionada = value
      this.df = false
    },
    toDate(value) {
      return new Date(value + 'T00:00')
    }
  }
}
</script>
